module.exports = __webpack_public_path__ + "img/Zain_B2B_Classera-2.fd29d20c.png";